// const io = require("socket.io-client"); // Cliente WebSocket
const feathers = require("@feathersjs/feathers");
// const socketio = require("@feathersjs/socketio-client");
const rest = require("@feathersjs/rest-client");
const auth = require("@feathersjs/authentication-client");
const axios = require("axios");

// const API_URL = "http://localhost:3030"; 
const API_URL = "https://depsec.unifap.br/depsec-api";

// Cria uma instância do Feathers para WebSockets
// const socketApp = feathers();
// const socket = io(API_URL, { transports: ["websocket"] });
// socketApp.configure(socketio(socket)); // Configura WebSockets
// socketApp.configure(
//   auth({
//     storageKey: "auth",
//   })
// );

// Cria uma instância do Feathers para REST
const app = feathers();
const restClient = rest(API_URL);
app.configure(restClient.axios(axios)); // Configura REST com Axios
app.configure(
  auth({
    storageKey: "auth",
  })
);

// module.exports = { socketApp, app }; // Exporta ambas as instâncias
module.exports = {app }; // Exporta ambas as instâncias

